import repository from "../Repository";

export default {
  async create(screenId, s3object, bucketName, base64) {
    return await repository.post(
      `file_s3_upload`,
      {
        s3object: s3object,
        bucket_name: bucketName,
        base64: base64
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
